import React, { useState } from 'react';
import { Alert, Modal, Typography } from 'antd';
import { useFormController } from '../../helpers/formManager';
import { useAddTenantMutation } from './api/useAddTenantMutation';
import { defaultValues } from './constants';
import { createClientPayload, getInitialValues } from './utils';
import { useExistingClient } from './useExistingClient';
import NameFields from './fields/NameFields';
import PhoneField from './fields/PhoneField';
import EmailField from './fields/EmailField';
import IsOwnerField from './fields/IsOwnerField';
import styles from './index.module.scss';

const AddTenantModal = ({
  visible,
  onCancel,
  addressId,
  address,
  tenant,
  onSuccess,
}) => {
  const isEdit = Boolean(tenant);

  const { control, handleSubmit, reset, setValue } = useFormController({
    defaultValues: getInitialValues(tenant),
  });

  const [responseError, setResponseError] = useState();

  const { existingClient, isSearching } = useExistingClient({
    control,
    setValue,
    excludeId: tenant?.id,
  });

  const { mutate, isLoading } = useAddTenantMutation({
    onSuccess: (client) => {
      onCancel();
      if (typeof onSuccess === 'function') onSuccess(client);
    },
  });

  const onSubmit = (values) => {
    setResponseError();

    if (!addressId) {
      setResponseError('Не удалось определить адрес для привязки жильца');
      return;
    }

    mutate({
      addressId,
      client: createClientPayload(values, existingClient?.id ?? tenant?.id),
    });
  };

  const handleAfterClose = () => {
    reset(defaultValues);
    setResponseError();
  };

  return (
    <Modal
      title={isEdit ? 'Редактировать жильца' : 'Добавить жильца'}
      visible={visible}
      onCancel={onCancel}
      onOk={handleSubmit(onSubmit)}
      okText={isEdit ? 'Сохранить' : 'Добавить'}
      okButtonProps={{ disabled: isSearching }}
      confirmLoading={isLoading}
      afterClose={handleAfterClose}
      maskClosable={false}
      centered
      destroyOnClose
      width={620}
    >
      <form className={styles.form}>
        {Boolean(address) && (
          <Typography.Text strong className={styles.address}>
            {address}
          </Typography.Text>
        )}

        <PhoneField control={control} loading={isSearching} />

        {Boolean(existingClient) && (
          <Alert
            type="info"
            showIcon
            message="Пользователь с таким номером телефона уже существует в системе и будет привязан к адресу"
          />
        )}

        <NameFields control={control} disabled={Boolean(existingClient)} />
        <EmailField control={control} disabled={Boolean(existingClient)} />
        <IsOwnerField control={control} />

        {Boolean(responseError) && (
          <Alert type="error" showIcon message={responseError} />
        )}
      </form>
    </Modal>
  );
};

export default AddTenantModal;
